var _style, _g, _defs, _defs2, _rect, _path, _defs3, _defs4, _rect2, _defs5, _defs6, _rect3, _defs7, _defs8, _rect4, _defs9, _defs10, _rect5, _defs11, _defs12, _rect6, _defs13, _defs14, _rect7, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngage4Logo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "167.9px",
    height: "41.9px",
    viewBox: "0 0 167.9 41.9",
    style: {
      enableBackground: "new 0 0 167.9 41.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{display:none;} .st1{clip-path:url(#SVGID_2_);} .st2{opacity:0.75;clip-path:url(#SVGID_4_);fill:#98B1D0;} .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#407DB1;} .st4{clip-path:url(#SVGID_6_);} .st5{clip-path:url(#SVGID_8_);fill:#3F7593;} .st6{clip-path:url(#SVGID_10_);} .st7{clip-path:url(#SVGID_12_);fill:#519DB9;} .st8{clip-path:url(#SVGID_14_);} .st9{clip-path:url(#SVGID_16_);fill:#468DB6;} .st10{clip-path:url(#SVGID_18_);} .st11{clip-path:url(#SVGID_20_);fill:#5AADBD;} .st12{clip-path:url(#SVGID_22_);} .st13{clip-path:url(#SVGID_24_);fill:#8CB4CB;} .st14{clip-path:url(#SVGID_26_);} .st15{clip-path:url(#SVGID_28_);fill:#89CDCC;} .st16{fill:#26282A;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M41.6,20.8c0-0.1,0-0.1,0-0.2C41.6,20.7,41.6,20.8,41.6,20.8C41.6,20.8,41.6,20.8,41.6,20.8 M21.5,41.6 c3.5-0.4,6.2-3.3,6.2-6.9c0-3.7-2.9-6.7-6.5-6.9c0.2,0,0.4,0,0.5,0c0.6-0.1,1.2-0.3,1.8-0.5c0.5-0.3,1.1-0.6,1.6-0.9 c0.4-0.4,0.9-0.8,1.3-1.3c0.3-0.5,0.6-1,0.9-1.6c0.2-0.6,0.4-1.2,0.5-1.8c0-0.3,0-0.6,0-0.9c0,0,0,0,0,0c0,1.8,0.8,3.6,2,4.9 c0.6,0.7,1.4,1.2,2.2,1.4c0.8,0.4,1.6,0.6,2.5,0.6c0.1,0,0.1,0,0.2,0c1.8-0.1,3.6-0.7,4.9-2c1.2-1.3,2-2.9,2-4.7 c0,1.4-0.2,2.7-0.5,4c-0.1,0.8-0.4,1.6-0.7,2.4c-0.7,1.9-1.5,3.7-2.7,5.3c-0.8,1-1.5,2-2.4,2.9c-0.9,0.9-1.9,1.6-2.9,2.4 c-1.6,1.2-3.5,2-5.4,2.6c-0.7,0.2-1.4,0.4-2.1,0.5C23.7,41.3,22.6,41.5,21.5,41.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 0,
    y: -0.1,
    width: 41.8,
    height: 41.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 16.8,
    className: "st2",
    width: 28.1,
    height: 28.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.8,27.8c-0.6,0-1.3,0-1.9-0.1c0.6,0.1,1.2,0.2,1.8,0.3c-1.2-0.2-2.4-0.5-3.5-1c0.6,0.2,1.1,0.5,1.7,0.7 c-1.1-0.5-2.1-1.1-3.1-1.8c0.5,0.4,0.9,0.7,1.4,1.1c-0.9-0.7-1.7-1.5-2.4-2.4c0.4,0.5,0.7,0.9,1.1,1.4c-0.7-1-1.3-2-1.8-3.1 c0.2,0.6,0.5,1.1,0.7,1.7c-0.5-1.1-0.8-2.3-1-3.5c0.1,0.6,0.2,1.2,0.2,1.8c-0.2-1.3-0.2-2.5,0-3.8c-0.1,0.6-0.2,1.2-0.3,1.8 c0.2-1.2,0.5-2.4,1-3.5c-0.2,0.6-0.5,1.1-0.7,1.7c0.5-1.1,1.1-2.1,1.8-3.1c-0.4,0.5-0.7,0.9-1.1,1.4c0.7-0.9,1.5-1.7,2.4-2.4 c-0.5,0.4-0.9,0.7-1.4,1.1c1-0.7,2-1.3,3.1-1.8c-0.6,0.2-1.1,0.5-1.7,0.7c1.1-0.5,2.3-0.8,3.5-1c-0.6,0.1-1.2,0.2-1.8,0.2 c1.3-0.2,2.5-0.2,3.8,0c-0.6-0.1-1.2-0.2-1.8-0.3c1.2,0.2,2.4,0.5,3.5,1c-0.6-0.2-1.1-0.5-1.7-0.7c1.1,0.5,2.1,1.1,3.1,1.8 c-0.5-0.4-0.9-0.7-1.4-1.1c0.9,0.7,1.7,1.5,2.4,2.4c-0.4-0.5-0.7-0.9-1.1-1.4c0.7,1,1.3,2,1.8,3.1c-0.2-0.6-0.5-1.1-0.7-1.7 c0.5,1.1,0.8,2.3,1,3.5c-0.1-0.6-0.2-1.2-0.2-1.8c0.1,0.6,0.1,1.3,0.1,1.9c0,1.8,0.8,3.6,2,4.9c0.6,0.7,1.4,1.2,2.2,1.4 c0.8,0.4,1.7,0.6,2.7,0.6c1.8-0.1,3.6-0.7,4.9-2c1.2-1.3,2-3,2-4.9c0-3.4-0.9-6.7-2.4-9.7c-0.7-1.4-1.7-2.7-2.8-4 c-1-1.3-2.3-2.3-3.6-3.3c-0.8-0.6-1.8-1.2-2.7-1.7c-1.5-0.7-3.1-1.4-4.7-1.7C23.7,0.2,22,0,20.2,0c-1.1,0-2.3,0.2-3.4,0.4 c-0.5,0.1-1.1,0.2-1.6,0.3C12,1.7,9.2,3.3,6.7,5.5C5.5,6.6,4.5,7.9,3.6,9.2c-1,1.4-1.6,2.9-2.2,4.4c-0.4,1-0.7,2.1-0.9,3.2 c-0.3,1.7-0.5,3.4-0.4,5.1c0.1,1.7,0.3,3.4,0.9,5C1.3,28,1.7,29,2.2,30c0.2,0.5,0.5,1,0.8,1.4c0.3,0.5,0.6,0.9,0.9,1.3 c0.6,0.9,1.3,1.7,2,2.5C6.2,35.7,6.6,36,7,36.4c0.8,0.7,1.7,1.4,2.6,2c1.4,0.9,2.9,1.6,4.5,2.1c1.6,0.6,3.2,0.8,4.9,1 c0.6,0.1,1.1,0.1,1.7,0.1c1.8,0,3.6-0.8,4.9-2c0.7-0.6,1.2-1.4,1.4-2.2c0.4-0.8,0.6-1.7,0.6-2.7c-0.1-1.8-0.7-3.6-2-4.9 C24.3,28.5,22.7,27.8,20.8,27.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M41.6,20.8c0,3.8-3.1,6.9-6.9,6.9c-3.8,0-6.9-3.1-6.9-6.9s3.1-6.9,6.9-6.9C38.5,13.9,41.6,17,41.6,20.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 0,
    y: -0.1,
    width: 41.8,
    height: 41.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.9,
    y: 10,
    className: "st5",
    width: 21.5,
    height: 21.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M6.9,27.7c-3.6,0-6.5-2.7-6.9-6.2C0,21,0,20.5,0,20c0.4-3.4,3.3-6.1,6.9-6.1c3.7,0,6.7,2.9,6.9,6.6 c0,0.2,0,0.5,0,0.7C13.6,24.8,10.6,27.7,6.9,27.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 0,
    y: -0.1,
    width: 41.8,
    height: 41.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -3.8,
    y: 10,
    className: "st7",
    width: 21.5,
    height: 21.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M20.8,41.6C20.8,41.6,20.8,41.6,20.8,41.6C20.7,41.6,20.7,41.6,20.8,41.6c-0.1,0-0.1,0-0.1,0 c-0.2,0-0.4,0-0.6,0c-3.5-0.4-6.2-3.3-6.2-6.9c0-3.7,2.9-6.7,6.5-6.9c0.1,0,0.2,0,0.4,0c0,0,0,0,0,0c1.9,0,3.5,0.8,4.9,2 c1.4,1.3,1.9,3.1,2,4.9c0,1-0.2,1.8-0.6,2.7c-0.3,0.9-0.8,1.6-1.4,2.2C24.4,40.8,22.6,41.6,20.8,41.6 C20.8,41.6,20.8,41.6,20.8,41.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -57.5,
    y: -20.1,
    width: 1264.8,
    height: 810.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23.9,
    className: "st9",
    width: 21.5,
    height: 21.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M21.1,13.9c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.4,0c-3.7-0.2-6.6-3.2-6.6-6.9c0-3.6,2.7-6.5,6.2-6.9 c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c3.5,0.3,6.3,3.3,6.3,6.9C27.7,10.6,24.8,13.7,21.1,13.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -57.5,
    y: -20.1,
    width: 1264.8,
    height: 810.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -3.8,
    className: "st11",
    width: 21.5,
    height: 21.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M20.9,41.6c1.7,0,3.5-0.8,4.8-2c0.7-0.6,1.2-1.4,1.4-2.2c0.4-0.8,0.6-1.7,0.6-2.7c-0.1-1.8-0.7-3.6-2-4.9 c-1.4-1.2-3-2-4.9-2c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0c3.6,0.2,6.5,3.2,6.5,6.9c0,3.6-2.7,6.5-6.2,6.9 C21.3,41.6,21.1,41.6,20.9,41.6 M20.8,41.6c0,0-0.1,0-0.1,0C20.7,41.6,20.7,41.6,20.8,41.6C20.7,41.6,20.7,41.6,20.8,41.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -57.5,
    y: -20.1,
    width: 1264.8,
    height: 810.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 23.9,
    className: "st13",
    width: 14.7,
    height: 21.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M20.1,0c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0,0.6,0c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.6,0 C20.2,0,20.1,0,20.1,0 M20.8,13.9c-0.1,0-0.2,0-0.4,0C20.5,13.9,20.6,13.9,20.8,13.9c0.1,0,0.2,0,0.4,0 C21,13.9,20.9,13.9,20.8,13.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -57.5,
    y: -20.1,
    width: 1264.8,
    height: 810.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: -3.8,
    className: "st15",
    width: 9,
    height: 21.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M48.3,9.7h15v4.6H53.1v4.2h9.5v4.6h-9.5v4.6h10.7v4.6H48.3V9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M66.1,16.8h4.5v2.1h0.1c0.1-0.3,0.4-0.6,0.6-0.9c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.4,1.3-0.6 c0.5-0.1,1-0.2,1.6-0.2c1.2,0,2.1,0.2,2.9,0.6c0.7,0.4,1.3,0.9,1.7,1.6c0.4,0.7,0.7,1.4,0.8,2.3c0.1,0.9,0.2,1.9,0.2,2.9v8.6H76 v-7.6c0-0.4,0-0.9,0-1.4c0-0.5-0.1-0.9-0.3-1.3c-0.2-0.4-0.4-0.7-0.7-1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.1-1.5,0.3 c-0.4,0.2-0.7,0.5-0.9,0.9c-0.2,0.4-0.3,0.8-0.4,1.3c-0.1,0.5-0.1,1-0.1,1.5v7.8h-4.7V16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M98.9,31.1c0,2.9-0.7,5.2-2.2,6.7c-1.4,1.5-3.6,2.3-6.6,2.3c-1.3,0-2.7-0.2-4-0.5s-2.5-0.9-3.6-1.8l2.6-4 c0.7,0.6,1.5,1.1,2.3,1.5c0.8,0.4,1.7,0.5,2.6,0.5c1.4,0,2.5-0.4,3.2-1.1c0.7-0.7,1-1.6,1-2.7v-1.5h-0.1c-0.5,0.7-1.2,1.3-2,1.6 c-0.8,0.3-1.5,0.5-2.3,0.5c-1.1,0-2.1-0.2-3-0.6c-0.9-0.4-1.7-1-2.3-1.7c-0.7-0.7-1.2-1.6-1.5-2.5c-0.4-1-0.5-2.1-0.5-3.2 c0-1,0.2-2,0.5-3c0.3-1,0.8-1.8,1.4-2.6c0.6-0.7,1.3-1.4,2.2-1.8c0.8-0.5,1.8-0.7,2.9-0.7c0.7,0,1.3,0.1,1.8,0.2 c0.5,0.1,1,0.3,1.5,0.6c0.4,0.2,0.8,0.5,1.1,0.8c0.3,0.3,0.6,0.6,0.7,0.8h0.1v-2.1h4.3V31.1z M87.1,24.5c0,0.5,0.1,1,0.3,1.5 c0.2,0.5,0.5,0.9,0.8,1.2c0.3,0.4,0.7,0.6,1.2,0.8c0.4,0.2,0.9,0.3,1.5,0.3c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.2-0.8 c0.3-0.4,0.6-0.8,0.8-1.2c0.2-0.5,0.3-0.9,0.3-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2c-0.3-0.4-0.7-0.6-1.2-0.8 c-0.5-0.2-0.9-0.3-1.5-0.3c-0.5,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.2,0.8c-0.3,0.4-0.6,0.8-0.8,1.2C87.2,23.5,87.1,24,87.1,24.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M111.2,30.4L111.2,30.4c-0.6,0.8-1.3,1.4-2.1,1.8c-0.9,0.4-1.8,0.5-2.7,0.5c-0.7,0-1.4-0.1-2-0.3 s-1.2-0.5-1.7-0.9c-0.5-0.4-0.9-0.9-1.2-1.5c-0.3-0.6-0.4-1.3-0.4-2.1c0-0.9,0.2-1.7,0.5-2.3c0.3-0.6,0.8-1.1,1.3-1.5 c0.5-0.4,1.2-0.7,1.9-0.9c0.7-0.2,1.4-0.4,2.2-0.5c0.8-0.1,1.5-0.2,2.3-0.2c0.8,0,1.5,0,2.1,0c0-0.9-0.3-1.5-0.9-2 c-0.6-0.5-1.3-0.8-2.1-0.8c-0.8,0-1.5,0.2-2.1,0.5c-0.6,0.3-1.2,0.8-1.7,1.4l-2.5-2.6c0.9-0.8,1.9-1.5,3-1.9 c1.2-0.4,2.4-0.6,3.6-0.6c1.4,0,2.5,0.2,3.4,0.5s1.6,0.9,2.1,1.6s0.9,1.5,1.1,2.5c0.2,1,0.3,2.1,0.3,3.4v7.9h-4.3V30.4z M110,25.6 c-0.4,0-0.8,0-1.3,0c-0.5,0-1,0.1-1.5,0.3c-0.5,0.1-0.9,0.4-1.2,0.7c-0.3,0.3-0.5,0.7-0.5,1.2c0,0.6,0.2,1,0.7,1.3 c0.5,0.3,1,0.4,1.5,0.4c0.5,0,0.9-0.1,1.3-0.2c0.4-0.1,0.8-0.3,1.1-0.5c0.3-0.2,0.6-0.5,0.8-0.9c0.2-0.4,0.3-0.8,0.3-1.3v-1H110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M133.3,31.1c0,2.9-0.7,5.2-2.2,6.7c-1.4,1.5-3.6,2.3-6.6,2.3c-1.3,0-2.7-0.2-4-0.5s-2.5-0.9-3.6-1.8l2.6-4 c0.7,0.6,1.5,1.1,2.3,1.5c0.8,0.4,1.7,0.5,2.6,0.5c1.4,0,2.5-0.4,3.2-1.1c0.7-0.7,1-1.6,1-2.7v-1.5h-0.1c-0.5,0.7-1.2,1.3-2,1.6 c-0.8,0.3-1.5,0.5-2.3,0.5c-1.1,0-2.1-0.2-3-0.6c-0.9-0.4-1.7-1-2.3-1.7c-0.7-0.7-1.2-1.6-1.5-2.5c-0.4-1-0.5-2.1-0.5-3.2 c0-1,0.2-2,0.5-3c0.3-1,0.8-1.8,1.4-2.6c0.6-0.7,1.3-1.4,2.2-1.8c0.8-0.5,1.8-0.7,2.9-0.7c0.7,0,1.3,0.1,1.8,0.2 c0.5,0.1,1,0.3,1.5,0.6c0.4,0.2,0.8,0.5,1.1,0.8c0.3,0.3,0.6,0.6,0.7,0.8h0.1v-2.1h4.3V31.1z M121.5,24.5c0,0.5,0.1,1,0.3,1.5 c0.2,0.5,0.5,0.9,0.8,1.2c0.3,0.4,0.7,0.6,1.2,0.8c0.4,0.2,0.9,0.3,1.5,0.3c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.2-0.8 c0.3-0.4,0.6-0.8,0.8-1.2c0.2-0.5,0.3-0.9,0.3-1.5s-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2c-0.3-0.4-0.7-0.6-1.2-0.8 c-0.5-0.2-0.9-0.3-1.5-0.3c-0.5,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.5-1.2,0.8c-0.3,0.4-0.6,0.8-0.8,1.2 C121.6,23.5,121.5,24,121.5,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M150.4,29.7c-0.7,1-1.7,1.7-2.8,2.3c-1.1,0.5-2.3,0.8-3.5,0.8c-1.2,0-2.3-0.2-3.3-0.6 c-1-0.4-1.9-0.9-2.7-1.6c-0.8-0.7-1.4-1.6-1.8-2.6c-0.4-1-0.7-2.1-0.7-3.4c0-1.2,0.2-2.4,0.7-3.4c0.4-1,1-1.9,1.8-2.6 c0.8-0.7,1.6-1.3,2.7-1.7c1-0.4,2.1-0.6,3.3-0.6c1.1,0,2.1,0.2,2.9,0.6c0.9,0.4,1.6,0.9,2.2,1.7c0.6,0.7,1.1,1.6,1.4,2.6 c0.3,1,0.5,2.1,0.5,3.4v1.5h-10.8c0.2,0.9,0.6,1.6,1.2,2.2c0.6,0.5,1.4,0.8,2.3,0.8c0.8,0,1.4-0.2,1.9-0.5c0.5-0.4,1-0.8,1.4-1.4 L150.4,29.7z M146.4,22.8c0-0.8-0.2-1.5-0.8-2.1c-0.5-0.6-1.2-0.9-2.1-0.9c-0.5,0-1,0.1-1.4,0.3c-0.4,0.2-0.7,0.4-1,0.7 s-0.5,0.6-0.7,0.9c-0.2,0.4-0.2,0.7-0.3,1.1H146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M162.5,26.8H153v-2.3l8.8-14.8h2.6v15.4h3.4v1.7h-3.4v5.6h-1.9V26.8z M162.5,11.8L162.5,11.8l-7.8,13.3h7.8 V11.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M137.8,35.6h0.4V38h0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6 c0,0.2,0,0.4-0.1,0.6c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2s-0.2-0.2-0.2-0.3h0v0.5h-0.4V35.6z M138.1,38.9c0,0.2,0,0.3,0.1,0.5 c0.1,0.1,0.1,0.3,0.3,0.4c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.1c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.3-0.1,0.4-0.3 c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.1,0.1-0.3,0.1-0.5s0-0.3-0.1-0.5c-0.1-0.1-0.1-0.3-0.2-0.4s-0.2-0.2-0.4-0.3 c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0.1c-0.1,0.1-0.3,0.1-0.4,0.3s-0.2,0.2-0.3,0.4C138.2,38.6,138.1,38.8,138.1,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M142.6,41.3c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0 l0-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2 l0.3-0.7l-1.2-2.9h0.4l1,2.5l0.9-2.5h0.4L142.6,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M145.8,35.9h1.1l1.1,2.9h0l1.1-2.9h1.1l-1.8,4.5h-0.8L145.8,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M150.6,36.4c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4 c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.4-0.2C150.6,36.7,150.6,36.5,150.6,36.4z M150.6,37.3h0.9v3.1 h-0.9V37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M155.5,40.4h-0.9V40h0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0 c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1-0.1-0.2-0.3-0.3-0.5s-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0.1-0.6s0.2-0.4,0.3-0.5 c0.1-0.2,0.3-0.3,0.4-0.4s0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.4,0.3h0v-2h0.9V40.4z M154.6,38.9 c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.2-0.6-0.2c-0.2,0-0.4,0.1-0.6,0.2s-0.2,0.3-0.2,0.6s0.1,0.4,0.2,0.6c0.1,0.1,0.3,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.6-0.2C154.6,39.3,154.6,39.1,154.6,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M158.2,40L158.2,40c-0.1,0.2-0.3,0.3-0.4,0.4c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.3,0-0.4-0.1 c-0.1,0-0.2-0.1-0.3-0.2s-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.2,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.3-0.1,0.4-0.1c0.2,0,0.3,0,0.5,0s0.3,0,0.4,0c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.2,0-0.3,0-0.4,0.1s-0.2,0.2-0.3,0.3l-0.5-0.5c0.2-0.2,0.4-0.3,0.6-0.4s0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7,0.1s0.3,0.2,0.4,0.3 s0.2,0.3,0.2,0.5s0.1,0.4,0.1,0.7v1.6h-0.9V40z M157.9,39.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0.1s-0.2,0.1-0.3,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3s0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3,0s0.2-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2 c0-0.1,0.1-0.2,0.1-0.3v-0.2H157.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M161.2,37.8h-0.8v1.9c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1 l0,0.3c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.3,0-0.3-0.1s-0.2-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.1-0.2 c0-0.1,0-0.2,0-0.3v-1.9h-0.6v-0.3h0.6v-0.8h0.4v0.8h0.8V37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M164.5,39.9c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.1-0.7,0.1c-0.2,0-0.4,0-0.6-0.1 c-0.2-0.1-0.3-0.2-0.5-0.3s-0.2-0.3-0.3-0.5s-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.3-0.5 c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.2,0.3,0.3,0.4 c0.1,0.2,0.1,0.3,0.1,0.5V39h-2.4c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0.1 c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.4-0.4L164.5,39.9z M164.2,38.7c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3 s-0.2-0.2-0.3-0.2c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0-0.4,0-0.5,0.1s-0.2,0.2-0.3,0.3s-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.2H164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M167.8,40c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.6-0.1 c-0.2-0.1-0.4-0.2-0.5-0.3s-0.2-0.3-0.3-0.5c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.3-0.5 c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.3,0.2,0.5,0.4l-0.3,0.2 c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.5,0.1c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.2,0.2-0.2,0.4 c-0.1,0.1-0.1,0.3-0.1,0.5s0,0.3,0.1,0.5c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.1 c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3L167.8,40z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage4Logo);
export default __webpack_public_path__ + "static/media/engage4_logo.bdf5a4747f1a778087d949b94444656c.svg";
export { ForwardRef as ReactComponent };